/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authagreementtermsurl3Inputs */



/**
* | output |
* | --- |
* | "https://www.chronock.ai/terms" |
*
* @param {Authagreementtermsurl3Inputs} inputs
* @param {{ locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }} options
* @returns {LocalizedString}
*/
const authagreementtermsurl3 = /** @type {((inputs?: Authagreementtermsurl3Inputs, options?: { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authagreementtermsurl3Inputs, { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-US") return /** @type {LocalizedString} */ ("https://www.chronock.ai/terms")
	if (locale === "fr-FR") return /** @type {LocalizedString} */ ("https://www.chronock.ai/terms")
	if (locale === "de-DE") return /** @type {LocalizedString} */ ("https://www.chronock.ai/terms")
	if (locale === "zh-TW") return /** @type {LocalizedString} */ ("https://www.chronock.ai/terms")
	if (locale === "ko-KR") return /** @type {LocalizedString} */ ("https://www.chronock.ai/terms")
	return /** @type {LocalizedString} */ ("https://www.chronock.ai/ja-JP/terms")
});
export { authagreementtermsurl3 as "authAgreementTermsUrl" }